import { ICallHistoryRecord } from '@webex/component-adapter-interfaces/dist/esm/src';
import { Logger } from '../../../logger/src/Logger';

export type OptimisticDeleteParams = {
  records: ICallHistoryRecord[];
  targetId: string;
  targetSessionId?: string;
};

export type OptimisticDeleteResult = {
  nextRecords: ICallHistoryRecord[];
  removedCount: number;
};

/**
 * Produce a new list with the target record removed. Matches on id or sessionId.
 * Pure function: does not mutate the input records.
 */
export function applyOptimisticDeletion({
  records,
  targetId,
  targetSessionId,
}: OptimisticDeleteParams): OptimisticDeleteResult {
  const matcher = (record: ICallHistoryRecord) => {
    const sessionId = record.sessionId ?? record.id;
    return (
      record.id === targetId ||
      sessionId === targetId ||
      (!!targetSessionId && sessionId === targetSessionId) ||
      (!!targetSessionId && record.id === targetSessionId)
    );
  };

  const nextRecords = (records || []).filter((r) => !matcher(r));
  const removedCount = (records || []).length - nextRecords.length;

  Logger.info(
    `[CallHistory] applyOptimisticDeletion: targetId=${targetId} targetSessionId=${targetSessionId} removed=${removedCount}`
  );

  return {
    nextRecords,
    removedCount,
  };
}
